import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ["product", "item", "panel"];

  connect() {
    this._showGroup(this._activeGroup());
    this._filterByGrade(this._activeGrade());
  }

  filterGroup(event) {
    const group = event.currentTarget.dataset.group;
    this.element.querySelectorAll(".past-tab").forEach(tab =>
      tab.classList.toggle("active", tab.dataset.group === group)
    );
    this._showGroup(group);
    const row = this.element.querySelector(`.past-cat-row--${group}`);
    const firstCat = row && row.querySelector(".past-cat-tab");
    if (firstCat) {
      row.querySelectorAll(".past-cat-tab").forEach(t => t.classList.remove("active"));
      firstCat.classList.add("active");
      this._filterByGrade(firstCat.dataset.grade);
    }
  }

  filter(event) {
    const grade = event.currentTarget.dataset.grade;
    const row = event.currentTarget.closest(".past-cat-row");
    if (row) {
      row.querySelectorAll(".past-cat-tab").forEach(tab =>
        tab.classList.toggle("active", tab.dataset.grade === grade)
      );
    }
    this._filterByGrade(grade);
  }

  // Product header clicked
  selectProduct(event) {
    const product = event.currentTarget.closest(".past-product");
    if (!product) return;

    const isMobile = window.innerWidth <= 900;

    if (product.dataset.variety) {
      // Leaf product (no sub-varieties)
      if (isMobile) {
        const isActive = product.classList.contains("active");
        this._clearAllMobile();
        if (!isActive) {
          product.classList.add("active");
          this._inlinePanel(product, product.dataset.variety);
        }
      } else {
        this._clearActive();
        product.classList.add("active");
        this._showPanel(product.dataset.variety);
      }
    } else {
      // Has sub-varieties — toggle accordion
      const isOpen = product.classList.contains("open");
      this.productTargets
        .filter(p => p.dataset.grade === product.dataset.grade && p !== product)
        .forEach(p => p.classList.remove("open"));
      product.classList.toggle("open", !isOpen);

      // On desktop auto-activate first variety when opening
      if (!isOpen && !isMobile) {
        const firstItem = product.querySelector("[data-pasturas-filter-target='item']");
        if (firstItem) {
          this._clearActive();
          product.classList.add("active", "open");
          firstItem.classList.add("active");
          this._showPanel(firstItem.dataset.variety);
        }
      }
    }
  }

  // Variety item clicked
  selectVariety(event) {
    event.stopPropagation();
    const item = event.currentTarget;
    const product = item.closest(".past-product");
    const isMobile = window.innerWidth <= 900;

    if (isMobile) {
      const isActive = item.classList.contains("active");
      this._clearAllMobile();
      if (!isActive) {
        if (product) product.classList.add("active", "open");
        item.classList.add("active");
        // Insert panel after the parent .past-product, not inside varieties list
        this._inlinePanel(product || item, item.dataset.variety);
      }
    } else {
      this._clearActive();
      if (product) product.classList.add("active", "open");
      item.classList.add("active");
      this._showPanel(item.dataset.variety);
    }
  }

  // ── private ──────────────────────────────────────────────────────

  _activeGroup() {
    const tab = this.element.querySelector(".past-tab.active");
    return tab ? tab.dataset.group : "gramineas";
  }

  _activeGrade() {
    const group = this._activeGroup();
    const row = this.element.querySelector(`.past-cat-row--${group}`);
    const tab = row && row.querySelector(".past-cat-tab.active");
    return tab ? tab.dataset.grade : null;
  }

  _showGroup(group) {
    this.element.querySelectorAll(".past-cat-row").forEach(row =>
      row.classList.toggle("active", row.classList.contains(`past-cat-row--${group}`))
    );
  }

  _filterByGrade(grade) {
    this._resetInlinePanels();

    this.productTargets.forEach(p => {
      const show = !grade || p.dataset.grade === grade;
      p.style.display = show ? "" : "none";
      if (!show) p.classList.remove("open", "active");
    });
    this.itemTargets.forEach(i => i.classList.remove("active"));
    this.panelTargets.forEach(p => p.classList.remove("active"));

    if (window.innerWidth <= 900) return;

    const first = this.productTargets.find(p => p.style.display !== "none");
    if (!first) return;

    if (first.dataset.variety) {
      first.classList.add("active");
      this._showPanel(first.dataset.variety);
    } else {
      first.classList.add("active", "open");
      const firstItem = first.querySelector("[data-pasturas-filter-target='item']");
      if (firstItem) {
        firstItem.classList.add("active");
        this._showPanel(firstItem.dataset.variety);
      }
    }
  }

  _clearActive() {
    this.productTargets.forEach(p => p.classList.remove("active"));
    this.itemTargets.forEach(i => i.classList.remove("active"));
    this.panelTargets.forEach(p => p.classList.remove("active"));
  }

  _clearAllMobile() {
    this._clearActive();
    this._resetInlinePanels();
    // Keep accordions open (don't remove "open" class)
  }

  _showPanel(variety) {
    this.panelTargets.forEach(p =>
      p.classList.toggle("active", p.dataset.variety === variety)
    );
  }

  // Always inserts panel after the .past-product element (not inside varieties)
  _inlinePanel(anchor, variety) {
    const product = anchor.closest(".past-product") || anchor;
    const panel = this.panelTargets.find(p => p.dataset.variety === variety);
    if (!panel) return;

    product.insertAdjacentElement("afterend", panel);
    panel.classList.add("active");
    setTimeout(() => panel.scrollIntoView({ behavior: "smooth", block: "nearest" }), 60);
  }

  _resetInlinePanels() {
    const container = this.element.querySelector(".past-detail-panels");
    if (!container) return;
    this.panelTargets.forEach(p => {
      p.classList.remove("active");
      if (p.parentNode !== container) container.appendChild(p);
    });
  }
}
